import axios from 'axios';
import {MessageBox, Message} from 'element-ui'
axios.defaults.timeout = 15000;
//axios.defaults.baseURL ='http://10.37.18.211:9007/'; //我们后台统一拦截的域名,济南环境
//axios.defaults.baseURL ='http://127.0.0.1:8080/api/'; //本地环境
axios.defaults.baseURL ='/w'; //测试环境
//http request 拦截器
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data);
    // config.headers = {
    //   'Content-Type':'application/x-www-form-urlencoded'
    // }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(response => {

  //判定业务逻辑错误信息，当后台提示用户识别失败的时候从新登录
  if(response.data.status=="failure"){
    if(response.data.errors!=undefined){
      if(response.data.errors[0].errCode==="403"||response.data.errors[0].errCode==="401"||response.data.errors[0].errCode==="400"){
        Message({
          message: response.data.errors[0].errMsg|| 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        sessionStorage.removeItem("token");
        Router.push({path:"/login"});
      }
    }
  }

  return response
}, err => {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        console.log('错误请求')
        break;
      case 401:
        console.log('未授权，请重新登录');
        sessionStorage.removeItem("token");
        break;
      case 403:
        console.log('拒绝访问')
        sessionStorage.removeItem("token");
        break;
      case 404:
        console.log('请求错误,未找到该资源')
        break;
      case 405:
        console.log('请求方法未允许')
        break;
      case 408:
        console.log('请求超时')
        break;
      case 500:
        console.log('服务器端出错')
        break;
      case 501:
        console.log('网络未实现')
        break;
      case 502:
        console.log('网络错误')
        break;
      case 503:
        console.log('服务不可用')
        break;
      case 504:
        console.log('网络超时')
        break;
      case 505:
        console.log('http版本不支持该请求')
        break;
      default:
        console.log(`连接错误${err.response.status}`)
    }
  } else {
    console.log('连接到服务器失败')
  }
  return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
  return new Promise((resolve,reject) => {
    axios.get(url,{
      params:params
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.post(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 分页查询封装方法，Post请求，Path携带查询条件和分页参数
 * @param {*} url 接口URL
 * @param {*} searchable  查询条件对象
 * @param {*} pageable  分页对象
 */
export function searchPages(url,searchable = {},size,page){
  return new Promise((resolve,reject) => {
    var params = new URLSearchParams();
    // 获取对象属性
    for(var i in searchable){
      if (searchable.hasOwnProperty(i) && typeof searchable[i] != "function") {
        let itemValue = searchable[i];
        if(itemValue!=''&&itemValue!=null){
          params.append("s_"+i,itemValue);
        }
      }
    }
    //处理分页数据
    if(size!=null){
      params.append('size',size);
    }else{
      params.append('size',20);
    }
    if(page!=null){
      params.append('page',page);
    }else{
      params.append('page',0);
    }

    axios.post(url,params)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.patch(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
  return new Promise((resolve,reject) => {
    axios.put(url,data)
      .then(response => {
        resolve(response.data);
      },err => {
        reject(err)
      })
  })
}

/**
 * 下面是获取数据的接口
 */
/**
 * 测试接口
 * 名称：exam
 * 参数：paramObj/null
 * 方式：fetch/post/patch/put
 */
export const server = {
  exam: function(paramObj){
    return post('/test',paramObj);
  }
}



// WEBPACK FOOTER //
// ./src/utils/request.js